var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 14.5389C6.66797 10.0422 6.66797 7.79388 8.06491 6.39694C9.46185 5 11.7102 5 16.2069 5H23.7957C28.2924 5 30.5408 5 31.9377 6.39694C33.3346 7.79388 33.3346 10.0422 33.3346 14.5389V21.6667C33.3346 27.4688 33.3346 30.3699 31.7507 32.3352C31.4301 32.733 31.0677 33.0954 30.6698 33.4161C28.7045 35 25.8035 35 20.0013 35V35C14.1991 35 11.2981 35 9.3328 33.4161C8.93492 33.0954 8.57254 32.733 8.25187 32.3352C6.66797 30.3699 6.66797 27.4688 6.66797 21.6667V14.5389Z",
    stroke: "url(#paint0_linear_623_3446)",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.0001L25 35.0001M15 30.0001L15 35.0001",
    stroke: "url(#paint1_linear_623_3446)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.3331L25 13.3331",
    stroke: "url(#paint2_linear_623_3446)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L25 20",
    stroke: "url(#paint3_linear_623_3446)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_3446",
    x1: 6.66797,
    y1: 20,
    x2: 33.3346,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_3446",
    x1: 20,
    y1: 30.0001,
    x2: 20,
    y2: 35.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_3446",
    x1: 15,
    y1: 13.8331,
    x2: 25,
    y2: 13.8331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_3446",
    x1: 15,
    y1: 20.5,
    x2: 25,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioManagement);
export default __webpack_public_path__ + "static/media/portfolio_management.9b80207116ebd91a36741aba06aa2be9.svg";
export { ForwardRef as ReactComponent };